import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";

/**
 * Generated class for the CheckboxCommentInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "checkbox-comment-input",
  templateUrl: "checkbox-comment-input.html",
})
export class CheckboxCommentInputComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() config: any;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  configOptions: string[] = [];
  options: string[] = [];
  details: any;

  required: boolean;
  disabled: boolean;
  readonly: boolean = false;

  supportOther: boolean = false;
  supportOtherOverride: boolean;
  otherConfig: any;
  otherRules: any;
  maxLength: number;
  existingData: any;
  selectedCount: number = 0;

  constructor(
    public formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    // console.log('Hello CheckboxCommentInputComponent Component');
  }

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    this.supportOther = this.config.supportOther;
    this.supportOtherOverride = this.config.supportOtherOverride;
    if (this.config.rules) {
      this.required = this.config.rules.required;
    }

    this.group.addControl(this.id, this.formBuilder.control({}));
    this.innerGroup = this.formBuilder.group({});

    this.configOptions = this.config.options;
    this.options = this.configOptions.slice(0);
    this.details = this.config.details;

    for (let key of this.options) {
      this.innerGroup.addControl(key, this.formBuilder.control(false));
      this.innerGroup.addControl(
        this.getCommentField(key),
        this.formBuilder.control("")
      );
    }

    if (this.supportOther || this.supportOtherOverride) {
      this.otherConfig = {
        id: "other",
        componentId: this.componentId + "Other",
        label: false,
        placeholder: this.config.otherPlaceholder || "other",
        rules: this.config.otherRules,
        readonly: this.readonly,
      };
    }

    this.existingData = this.group.controls[this.id].value || null;

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      let exisData = false;
      if (data && data.length === 0 && this.existingData !== null) {
        data = this.existingData;
        this.existingData = null;
        exisData = true;
      }

      let innerGroup = this.innerGroup;

      if (data === null) {
        let emptyVal = {};
        for (let control of Object.keys(innerGroup.controls)) {
          if (this.supportOther && control === "other") {
            emptyVal[control] = null;
          } else {
            emptyVal[control] = this.isCommentField(control) ? "" : false;
          }
        }
        innerGroup.setValue(emptyVal);
      } else if (data && !this.checkCurrentState(data)) {
        let currentState = innerGroup.value;
        let configOptions = this.configOptions;
        for (let key of Object.keys(innerGroup.controls)) {
          if (
            !this.isCommentField(key) &&
            configOptions.indexOf(key) == -1 &&
            _.keys(data).indexOf(key) == -1 &&
            key !== "other"
          ) {
            innerGroup.removeControl(key);
            innerGroup.removeControl(this.getCommentField(key));
            this.options.splice(this.options.indexOf(key), 1);
            delete currentState[key];
          } else {
            currentState[key] = currentState[key];
          }
        }

        if (!exisData) {
          for (let key of _.keys(data)) {
            if (currentState[key] == undefined) {
              if (!this.isCommentField(key)) {
                this.options.push(key);
              }
              innerGroup.addControl(key, this.formBuilder.control(data[key]));
              innerGroup.controls[key].valueChanges.subscribe((data) => {
                if (data === false) {
                  this.options = this.options.filter(
                    (option) => option !== key
                  );
                  innerGroup.removeControl(key);
                  innerGroup.removeControl(this.getCommentField(key));
                }
              });
            }
            if (this.disabled || this.readonly) {
              innerGroup.controls[key].disable({ emitEvent: false });
            }
            currentState[key] = data[key];
          }
          if (this.supportOther || this.supportOtherOverride) {
            currentState["other"] = "";
          }
        }

        if (this.supportOther || this.supportOtherOverride) {
          data["other"] = "";
        }
        innerGroup.setValue(currentState);
      }
      this.toggleControlDisable();
    });

    this.innerGroup.valueChanges.subscribe((data) => {
      if (this.supportOther) {
        delete data["other"];
      }
      let values = this.getValueArray(data);

      let tempObj = {};
      for (let option of values) {
        tempObj[option] = data[option];
        tempObj[this.getCommentField(option)] =
          data[this.getCommentField(option)];
      }
      this.group.controls[this.id].setValue(tempObj);

      this.selectedCount = values.length;
      this.group.markAsDirty();

      this.group.controls[this.id].setErrors(this.getErrors());
    });

    this.toggleControlDisable();

    this.group.controls[this.id].setValue(this.group.controls[this.id].value);
  }

  toggleControlDisable(): void {
    let outerDisabled = this.group.controls[this.id].disabled;
    if (outerDisabled !== this.disabled) {
      if (this.disabled || this.readonly) {
        this.innerGroup.disable({ emitEvent: false });
      } else {
        this.innerGroup.enable({ emitEvent: false });
      }
    }
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  addOther() {
    let otherVal = "" + this.innerGroup.controls["other"].value;
    //prevent adding duplicates
    if (
      this.options.filter(
        (option) =>
          //get the translation, compare to otherVal
          this.translate.instant(option).toString().toLowerCase() ===
          otherVal.toLowerCase()
      ).length > 0
    ) {
      return;
    }

    if (this.otherConfig.rules) {
      if (this.otherConfig.rules.maxLength) {
        if (otherVal.length < this.otherConfig.rules.maxLength) {
          this.setOtherValue(otherVal);
        }
      } else {
        this.setOtherValue(otherVal);
      }
    } else {
      if (otherVal.length) {
        this.setOtherValue(otherVal);
      }
    }
  }

  setOtherValue(otherVal: string) {
    this.options.push(otherVal);
    this.innerGroup.addControl(otherVal, this.formBuilder.control(true));
    this.innerGroup.addControl(
      this.getCommentField(otherVal),
      this.formBuilder.control("")
    );
    this.innerGroup.controls[otherVal].valueChanges.subscribe((data) => {
      if (data === false) {
        this.options = this.options.filter((option) => option !== otherVal);
        this.innerGroup.removeControl(otherVal);
        this.innerGroup.removeControl(this.getCommentField(otherVal));
      }
    });
    this.innerGroup.controls["other"].setValue("");
  }

  getValueArray(data: object) {
    let valArray: string[] = [];
    for (let key of Object.keys(data)) {
      if (data[key] === true) {
        valArray.push(key);
      }
    }
    // console.log( "Determined value array: ", valArray );
    return valArray;
  }

  checkCurrentState(data: string[]): boolean {
    let valArray = this.getValueArray(this.innerGroup.value);
    let dataArray = this.getValueArray(data);

    if (valArray.length !== dataArray.length) {
      return false;
    }

    let numInconsistent = valArray.filter((val) => {
      _.keys(data).indexOf(val) == -1;
    }).length;

    return numInconsistent == 0;
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (
      this.required &&
      this.getValueArray(this.innerGroup.value).length === 0
    ) {
      errors["required"] = true;
    }
    // console.log( "Determined checkbox errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }

  onCheckboxChange(option) {
    if (this.configOptions.indexOf(option) !== -1) {
      this.innerGroup.controls[this.getCommentField(option)].setValue("");
    }
  }

  getCommentField(fieldName: string): string {
    return fieldName + "_comment";
  }

  isCommentField(fieldName: string): boolean {
    return fieldName.indexOf("_comment") > -1;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/checkbox-comment-input/checkbox-comment-input.ts